import React, { useState, useEffect, useCallback } from 'react';
import { Dropdown, Menu, message } from 'antd';
import {
    EyeOutlined,
    RightOutlined,
    FullscreenOutlined,
    FullscreenExitOutlined,
} from '@ant-design/icons';
import './style.css';
import { useFullView, setFullView } from '../../../utils/fullView';

// Renders a menu row matching the shared `.menu-dropdown` look (icon | text).
const menuItem = (icon, text) => (
    <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left">{icon}</span>
        <span className="menu-dropdown-item-text">{text}</span>
    </span>
);

const ViewMenu = () => {
    const [viewMenuVisible, setViewMenuVisible] = useState(false);
    const [isFullScreen] = useFullView();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const exitFullScreen = useCallback(() => {
        setFullView(false);
    }, []);

    const enterFullScreen = useCallback(() => {
        setFullView(true);
        message.info({ content: 'Press Esc to exit full screen', duration: 2 });
    }, []);

    // Esc exits full screen, mirroring Google Docs.
    useEffect(() => {
        if (!isFullScreen) return undefined;
        const onKeyDown = (e) => {
            if (e.key === 'Escape') exitFullScreen();
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [isFullScreen, exitFullScreen]);

    const handleMenuClick = ({ key }) => {
        if (key === 'fullscreen') {
            if (isFullScreen) exitFullScreen();
            else enterFullScreen();
        }
        setViewMenuVisible(false);
    };

    const viewMenu = (
        <Menu
            onClick={handleMenuClick}
            className="menu-dropdown"
            selectable={false}
        >
            <Menu.Item key="fullscreen">
                {menuItem(
                    isFullScreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />,
                    isFullScreen ? 'Exit full screen' : 'Full screen',
                )}
            </Menu.Item>
        </Menu>
    );

    return (
        <Dropdown
            overlay={viewMenu}
            trigger={['click']}
            visible={viewMenuVisible}
            onVisibleChange={setViewMenuVisible}
            placement={isMobile ? 'rightTop' : undefined}
        >
            <div
                className="navTabItem"
                role="menuitem"
                tabIndex={0}
                onMouseDown={(e) => e.preventDefault()}
            >
                <span className="nav-tab-trigger">
                    <span className="nav-tab-icon"><EyeOutlined /></span>
                    <span className="nav-tab-label">View</span>
                    <span className="nav-tab-arrow"><RightOutlined /></span>
                </span>
            </div>
        </Dropdown>
    );
};

export default ViewMenu;
